export const DEFAULT_PAGE_SIZE = 25
export const DEFAULT_PAGE_NUMBER = 1
export const DEFAULT_SORT_BY = 'createdAt'
export const DEFAULT_SORT_DIRECTION = 'desc'
